import PropTypes from "prop-types";

const BtnPrimaryL = ({ buttonCTA, onClickLink, type }) => {
  return (
    <button
      className="btn-primary-l text-base"
      onClick={onClickLink}
      type={type}
    >
      {buttonCTA}
    </button>
  );
};

BtnPrimaryL.propTypes = {
  buttonCTA: PropTypes.string.isRequired,
  onClickLink: PropTypes.func,
  type: PropTypes.string,
};

export default BtnPrimaryL;
